import { render, staticRenderFns } from "./JoinPartie.vue?vue&type=template&id=d8f252b0&scoped=true"
import script from "./JoinPartie.vue?vue&type=script&lang=js"
export * from "./JoinPartie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f252b0",
  null
  
)

export default component.exports